<script lang="ts" setup>
import { useLanguages } from "@/use/common";
import { ref } from "vue";
import { useGlobalUser } from "@/stores/globalUser";
import { showLoadingToast, showSuccessToast } from "vant";
import i18n, { getLocaleIdByLocale, setGalGameLanguage } from "@/locales";
import api from "@/modules/api";
import { useI18n } from "vue-i18n";

const languages = useLanguages();
const user = useGlobalUser();
const { locale } = useI18n({ useScope: "global" });

const languageValue = ref<number>(
  user.isLogin
    ? user.settingDisplayLanguageId
    : getLocaleIdByLocale(locale.value)
);

const onLanguagePickerConfirm = async (e: Event) => {
  const newLang = (e.target as unknown as { value: string }).value;
  console.log(newLang);
  const loading = showLoadingToast(i18n.global.t("Message.switchingLanguage"));
  try {
    await user.updateUserApi({
      settingDisplayLanguageId: parseInt(newLang),
      settingMateLanguageId: parseInt(newLang),
    });

    setGalGameLanguage(locale.value);
    loading.close();
    showSuccessToast(i18n.global.t("Message.successfully"));
    location.reload();
  } finally {
    loading.close();
  }
};
</script>
<template>
  <div class="lg:pt-[var(--top-nav-height)]">
    <ThreadsNav :show-center="false" class="lg:hidden" show-back />
    <div class="flex flex-col gap-2 text-sm px-4">
      <div class="flex flex-col gap-4">
        <div class="font-bold text-lg">
          {{ $t("setting.language") }}
        </div>
        <select
          :value="languageValue"
          class="select select-bordered w-full rounded"
          @change="onLanguagePickerConfirm"
        >
          <option
            v-for="(lang, idx) in languages"
            :key="idx"
            :value="lang.value"
          >
            {{ lang.text }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
